import React, { useState, useRef, useEffect } from 'react';
import './ChatBot.css';

const API_BASE = window.location.hostname === 'localhost' ? 'http://localhost:4000' : '';

const ChatBot = () => {
    const [abierto, setAbierto] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [historial, setHistorial] = useState([
        { role: 'assistant', content: '¡Hola! Soy el asistente IA de NeoClic. ¿En qué tecnología te puedo asesorar hoy?' }
    ]);
    const [cargando, setCargando] = useState(false);
    const mensajesFinRef = useRef(null);

    // Auto-scroll hacia abajo cuando hay un nuevo mensaje
    useEffect(() => {
        mensajesFinRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [historial]);

    const enviarMensaje = async (e) => {
        e.preventDefault();
        if (!mensaje.trim()) return;

        const nuevoMensajeUsuario = { role: 'user', content: mensaje };
        const nuevoHistorial = [...historial, nuevoMensajeUsuario];
        
        setHistorial(nuevoHistorial);
        setMensaje('');
        setCargando(true);

        try {
            const res = await fetch(`${API_BASE}/api/chat`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                // Enviamos el mensaje nuevo y todo el contexto anterior (sin incluir el primer saludo para ahorrar datos)
                body: JSON.stringify({ 
                    mensajeUsuario: nuevoMensajeUsuario.content,
                    historial: historial.filter(m => m.role !== 'system').slice(-4) // Solo mandamos los últimos 4 mensajes para contexto
                })
            });

            const data = await res.json();
            
            if (res.ok) {
                setHistorial(prev => [...prev, { role: 'assistant', content: data.respuesta }]);
            } else {
                setHistorial(prev => [...prev, { role: 'assistant', content: 'Error de conexión con la IA.' }]);
            }
        } catch (error) {
            setHistorial(prev => [...prev, { role: 'assistant', content: 'Tengo problemas técnicos, por favor intenta en un momento.' }]);
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="chatbot-container">
            {/* Botón flotante para abrir/cerrar */}
            <button className="chatbot-toggle" onClick={() => setAbierto(!abierto)}>
                {abierto ? '✕' : '🤖'}
            </button>

            {/* Ventana del Chat */}
            {abierto && (
                <div className="chatbot-window">
                    <div className="chatbot-header">
                        <h4>Asistente IA NeoClic</h4>
                    </div>
                    
                    <div className="chatbot-messages">
                        {historial.map((msg, index) => (
                            <div key={index} className={`chat-bubble-container ${msg.role === 'user' ? 'user-container' : 'bot-container'}`}>
                                <div className={`chat-bubble ${msg.role === 'user' ? 'user-bubble' : 'bot-bubble'}`}>
                                    {msg.content}
                                </div>
                            </div>
                        ))}
                        {cargando && (
                            <div className="chat-bubble-container bot-container">
                                <div className="chat-bubble bot-bubble typing-indicator">
                                    <span>.</span><span>.</span><span>.</span>
                                </div>
                            </div>
                        )}
                        <div ref={mensajesFinRef} />
                    </div>

                    <form className="chatbot-input-area" onSubmit={enviarMensaje}>
                        <input 
                            type="text" 
                            placeholder="Escribe tu pregunta..." 
                            value={mensaje}
                            onChange={(e) => setMensaje(e.target.value)}
                            disabled={cargando}
                        />
                        <button type="submit" disabled={cargando || !mensaje.trim()}>➤</button>
                    </form>
                </div>
            )}
        </div>
    );
};

export default ChatBot;